import React, { useEffect, useState } from "react";
import styles from "./PopUpEligibility.module.css";

export default function PopUpEligibility({
  show,
  title,
  paragraph,
  buttonText,
  onClose,
  appLanguage,
}) {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    // Add direct localStorage reading
    const getEntries = localStorage.getItem('ayaAppEntries');
    const getAssets = localStorage.getItem('ayaAppAssets');

    if (!getEntries || !getAssets) {
      console.warn('Contentful data not available in localStorage');
      return;
    }

    const entries = JSON.parse(getEntries);
    const assets = JSON.parse(getAssets);

    // Add helper function inside useEffect
    const getAssetUrl = (assetId, language = appLanguage || 'es-VE') => {
      const asset = assets.find(a => a.sys.id === assetId);
      if (!asset?.fields?.file) return '';
      
      // Try localized file first
      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      // Fallback to any available file
      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }
      
      return '';
    };

    // Load the image using the same logic as Onboarding2NewFUMTips
    setImageUrl(getAssetUrl("3KztPVcLQnzoqXk6MdvpBK", appLanguage) || "");
  }, [appLanguage]);

  if (!show) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.popup}>
        {imageUrl && <img src={imageUrl} alt="Popup Illustration" className={styles.image} />}
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.description}>{paragraph}</p>
        <button className={styles.button} onClick={onClose}>
          {buttonText}
        </button>
      </div>
    </div>
  );
}